"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const LabeledTextAreaFieldWidget_1 = tslib_1.__importDefault(require("../widget/LabeledTextAreaFieldWidget"));
class WCAGTextAreaField extends LabeledTextAreaFieldWidget_1.default {
    constructor(args) {
        super({ ...args });
    }
    setRows(rows) {
        this.fieldElement.rows = rows;
    }
    decorateLabeledTextAreaFieldWidgetElement(options) {
        this.element = document.createElement("div");
        this.element.classList.add("text-area-field");
        this.add(this.labelElement);
        this.add(this.fieldElement);
        this.add(this.hintElement);
        this.add(this.characterLimitElement);
        if (options.rows) {
            this.fieldElement.rows = options.rows;
        }
    }
    parseFieldElementValue(inputValue) {
        return inputValue;
    }
    setFieldElementValue(value) {
        this.fieldElement.value = !value ? null : value;
    }
}
exports.default = WCAGTextAreaField;
//# sourceMappingURL=WCAGTextAreaField.js.map